import React from "react"
import PropTypes from 'prop-types';
import { ReactComponent as Arrow } from "../../../../assets/images/habitacional/arrow-complete-icon.svg"
import * as S from "./BackNavigationButton.Style"

const BackNavigationButton = ({href, isPadding}) => {
    return (
        <S.BackNavigationButtonSection isPadding={isPadding}>
            <S.BackNavigationButtonContent href={href}>
                <S.BackNavigationIcon><Arrow/></S.BackNavigationIcon>
                <S.BackNavigationText >Voltar</S.BackNavigationText>
            </S.BackNavigationButtonContent>
        </S.BackNavigationButtonSection>
    )
}

export default BackNavigationButton

BackNavigationButton.propTypes = {
    href: PropTypes.string.isRequired,
};